<template>
  <p v-bind="$attrs">
    {{ description }}
  </p>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      required: true
    },
    limit: {
      type: Number,
      default: 95
    }
  },
  computed: {
    description() {
      const text =
        this.item.content_lead ||
        this.item.content_short_description ||
        this.item.content_description ||
        this.item.content_body_summary ||
        this.item.content_body ||
        '';

      return text.length <= this.limit ? text : text.slice(0, this.limit) + '...';
    }
  }
};
</script>
